export default "__VITE_ASSET__GBK9Emfi__"